'use client';
import { SportMatchModel } from '@nf/types/odds';
import { scoreboardService } from '@/services/scoreboard.service';
import { useTranslations } from 'next-intl';

export const MatchLiveScore = ({ match }: { match: SportMatchModel }) => {
	const scoreList = scoreboardService.getAllSportScore(match)[0]?.text.split('-');
	const t = useTranslations('General');

	if (!scoreList) {
		return null;
	}

	if (scoreList.length > 1) {
		return (
			<div className="select-match-item__scores">
				<div className="team-score">{scoreList[0]}</div>
				<div className="team-score">{scoreList[1]}</div>
			</div>
		);
	} else {
		return (
			<div className="select-match-item__scores">
				<div className="team-score">{`${t('lbl_round')}${scoreList[0]}`}</div>
			</div>
		);
	}
};
